import { connect } from 'react-redux';
import { mapPlotMetadataToPlotId } from 'js/containers/legacy/GraphSection';
import PlotCheckboxList from 'js/components/legacy/PlotCheckboxList';
import { updatePlotCheckbox } from 'js/store/actions/plotCheckboxes';
export default connect(function (state, ownProps) {
  return {
    plotCheckboxes: state.plotCheckboxes[mapPlotMetadataToPlotId(ownProps.plotMetadata)]
  };
}, function (dispatch, ownProps) {
  return {
    plotCheckboxChanged: function plotCheckboxChanged(plotCheckboxId, checked) {
      dispatch(updatePlotCheckbox(mapPlotMetadataToPlotId(ownProps.plotMetadata), plotCheckboxId, checked));
    }
  };
})(PlotCheckboxList);